import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const npmBeacon: Example = {
  id: "npm-beacon",
  title: "Compromised package beacon (ESM)",
  group: "incident",
  environment: "browser",
  mode: "module",
  summary: "An ESM dependency fingerprints the page and beacons out tokens",
  explainer:
    "Modeled on compromised-npm-package incidents. The two `import`s (`uuid`, `axios`) have no real code, so Afterimage serves recording stub modules and logs a codeload event for each. The package reads navigator/screen/Intl traits, gates on `location.hostname` looking real, then posts `location.href`, the `auth_token`, and `document.cookie` through the stubbed `axios` (a stubbed probe call) and again with `navigator.sendBeacon`, a NET beacon to pkg-metrics.example whose body carries the stolen fields.",
  code,
  expect: golden as Example["expect"],
};
